import React from 'react';
import { observer, inject } from 'mobx-react';
import ButtonSpinner from '../ButtonSpinner';
import {Modal,FormGroup,FormControl,ControlLabel,Checkbox,Button} from 'react-bootstrap';

@inject('userStore')
@observer
export default class AddUser extends React.Component {
    componentDidMount() {

    }
    render() {
        return (
            <Modal show={this.props.userStore.ShowAddUser} >
                <Modal.Header>Add/Edit User</Modal.Header>
                <Modal.Body>
                    <FormGroup controlId="firstName" >
                        <ControlLabel>First Name</ControlLabel>
                        <FormControl type="text" value={this.props.userStore.AddUserRequest.FirstName} name="FirstName" placeholder="First Name" onChange={(e) => { this.props.userStore.UpdateAddUserProperty(e.target.name, e.target.value) }} />
                    </FormGroup>
                    <FormGroup controlId="lastName" >
                        <ControlLabel>Last Name</ControlLabel>
                        <FormControl type="text" value={this.props.userStore.AddUserRequest.LastName} name="LastName" placeholder="Last Name" onChange={(e) => { this.props.userStore.UpdateAddUserProperty(e.target.name, e.target.value) }} />
                    </FormGroup>
                    <FormGroup controlId="Email" >
                        <ControlLabel>Email</ControlLabel>
                        <FormControl type="text" value={this.props.userStore.AddUserRequest.Email} name="Email" placeholder="Email" onChange={(e) => { this.props.userStore.UpdateAddUserProperty(e.target.name, e.target.value) }} />
                    </FormGroup>
                    <FormGroup controlId="Ext" >
                        <ControlLabel>Ext</ControlLabel>
                        <FormControl type="text" value={this.props.userStore.AddUserRequest.Ext} name="Ext" placeholder="user extension" onChange={(e) => { this.props.userStore.UpdateAddUserProperty(e.target.name, e.target.value) }} />
                    </FormGroup>
                    <FormGroup controlId="IsSupportUser" >
                        <Checkbox name="IsSupportUser" checked={this.props.userStore.AddUserRequest.IsSupportUser} onChange={(e) => this.props.userStore.UpdateAddUserProperty(e.target.name, e.target.checked)} > Is Support user </Checkbox>
                    </FormGroup>
                    <FormGroup controlId="Role" >
                        <ControlLabel>Role</ControlLabel>
                        <FormControl name="UserType" componentClass="select" value={this.props.userStore.AddUserRequest.UserType} onChange={(e)=>{ this.props.userStore.UpdateAddUserProperty(e.target.name,e.target.value) }} >
                            <option value="select">select user role</option>
                            <option value="Admin">Admin</option>
                            <option value="User">User</option>
                        </FormControl>
                    </FormGroup>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={()=>{ this.props.userStore.ShowOrHideAddUserModal(); }}>Close</Button>
                    <Button onClick={()=>{ this.props.userStore.AddUser(); }}>Save <ButtonSpinner IsLoading={this.props.userStore.LoadingAddUser}/> </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Users/AddUser.js